/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeCheckbox,
  BaSeDatePicker,
  BaSeDialogContext,
  BaSeGrid,
  BaSeGridItem,
  BaSeInput,
  BaSeOptionPicker,
  BaSePopupButton,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import { useCityController } from '../../../../../../hooks/controllers/city-controller';
import { useUfController } from '../../../../../../hooks/controllers/uf-controller';
import { useMessage } from '../../../../../../hooks/messages/useMessage';
import { useModule } from '../../../../../../hooks/module/module';
import { useRegionalService } from '../../../../../../hooks/services/regional-service';
import { formatarData } from '../../../../../../utils/formatters/dateMask';
import { useManageClass } from '../../hook/useManageClass';
import UfFilterDisabled from '../manage-class/uf-filter-disabled';
import { AlignButtons, AlignInformations } from './form-new-class-style';
import SeeDataNewClassRoom from './see-data-new-class-room';

// import { Container } from './styles';
const cache = Sebrae.StorageUtil.inTemporaryStore();
const cacheKeySebrae = '@empretec:sebrae';
const COLOR_DESCRIPTION = '#394D60';
const COLOR_DESCRIPTION_DESTAQ = '#0000c4';

function FormCreateNewClassRoom({ closeFormNewClass, handleUpdateColumns }) {
  const { getUfs } = useUfController();
  const { returnRegionals } = useRegionalService();
  const { getCitiesByUf } = useCityController();
  const { moduleSelected } = useModule();
  const { handleError } = useMessage();
  const { showModal } = React.useContext(BaSeDialogContext);
  const { openDialogNewClassRoom } = useManageClass();
  //const { hasRole } = Sebrae.useAuth();

  const [listUfs, setListUfs] = React.useState([]);
  const [selectedUF, setSelectedUF] = React.useState([]);
  const [ufGestorDefault, setUfGestorDefault] = React.useState([]);

  const [acept, setAcept] = React.useState(false);

  const [selectedCITY, setSelectedCITY] = React.useState([]);

  const [regionalSelected, setRegionalSelected] = React.useState([]);
  const [listRegionals, setListRegionals] = React.useState([]);
  const [listCityByRegional, setListCityByRegional] = React.useState([]);

  const [dtoCreateClass, setDtoCreateClass] = React.useState({
    beginDate: '',
    endDate: '',
    cityId: 0,
    moduleId: 0,
    seminarValue: '',
    hidePortal: true,
  });

  const [initialDate, setInitialDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);

  const handleChange = React.useCallback((name, value) => {
    setDtoCreateClass((prevDto) => ({
      ...prevDto,
      [name]: value,
    }));
  }, []);

  const getRegionalsbYuF = React.useCallback(
    (idUf) => {
      returnRegionals({ idUf, status: true }).then((response) => {
        const responseFormated = response.map((item) => ({
          ...item,
          label: item.name,
          name: item.name,
        }));
        setListRegionals(responseFormated);
      });
    },
    [returnRegionals],
  );

  React.useEffect(() => {
    if (cache.getItem(cacheKeySebrae) !== 'NA' && ufGestorDefault.length > 0) {
      const idUf = ufGestorDefault.map((i) => i.id)[0];
      returnRegionals({ idUf, status: true })
        .then((response) => {
          const responseFormated = response.map((item) => ({
            ...item,
            label: item.name,
            name: item.name,
          }));
          setListRegionals(responseFormated);
        })
        .catch(() => setListRegionals([]));
    }
  }, [returnRegionals, ufGestorDefault]);

  React.useEffect(() => {
    const load = async () => {
      try {
        const response = await getUfs();
        if (cache.getItem(cacheKeySebrae) !== 'NA') {
          const ufDef = await response.find(
            (res) => res.sigla === cache.getItem(cacheKeySebrae),
          );
          setUfGestorDefault([ufDef]);
          getCitiesByUf({ id: ufDef.id });
          setSelectedUF([ufDef]);
        }
        setListUfs(response);
      } catch (e) {
        setListUfs([]);
      }
    };
    load();
  }, [getUfs, getCitiesByUf]);

  const openDialogConfirmationClassRoom = React.useCallback(
    (option) => {
      return showModal({
        actions: [],
        size: 'small',
        title: 'Criar turma',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        breakpointDelimiter: 'mobileLarge',
        content: ({ closeModal, emitEvent }) => (
          <SeeDataNewClassRoom
            option={option}
            closeModal={closeModal}
            closeFormNewClass={closeFormNewClass}
            beginDate={initialDate}
            endDate={endDate}
            empretecName={moduleSelected?.name}
            uf={selectedUF[0]}
            regionalSelected={regionalSelected}
            cidade={selectedCITY[0]}
            dtoCreateClass={dtoCreateClass}
            valueSeminar={dtoCreateClass.seminarValue}
            handleUpdateColumns={handleUpdateColumns}
            active={acept}
          />
        ),
        onChooseAction: (action) => {
          if (action === 'close') {
            closeFormNewClass('close');
          } else if (action === 'new') {
            closeFormNewClass('new');
            setTimeout(() => {
              openDialogNewClassRoom();
            }, 1500);
          }
        },
      });
    },
    [
      showModal,
      closeFormNewClass,
      initialDate,
      endDate,
      moduleSelected,
      selectedUF,
      regionalSelected,
      selectedCITY,
      dtoCreateClass,
      handleUpdateColumns,
      acept,
      openDialogNewClassRoom,
    ],
  );

  const validate = React.useCallback(
    (tag) => {
      if (
        initialDate === null ||
        endDate === null ||
        selectedUF.length === 0 ||
        selectedCITY.length === 0 ||
        !dtoCreateClass.seminarValue ||
        dtoCreateClass.seminarValue === '' ||
        regionalSelected.length === 0
      ) {
        handleError('É necessário preencher todas as informações da turma!');
        return;
      }
      openDialogConfirmationClassRoom(tag);
    },
    [
      initialDate,
      endDate,
      selectedUF.length,
      selectedCITY.length,
      dtoCreateClass.seminarValue,
      regionalSelected.length,
      openDialogConfirmationClassRoom,
      handleError,
    ],
  );

  const TODAY = new Date();
  const MORE_INITIAL_DATE = new Date(
    new Date(initialDate).getTime() + 86400000,
  );

  const message = (
    <BaSeSmall1 color={COLOR_DESCRIPTION}>
      Ao ser marcada essa opção, o sistema não apresentará a turma na lista de
      turmas para cadastro do candidato no portal. A turma poderá ter sua gestão
      realizada no gerenciamento de turma e será apresentada em tom{' '}
      <b style={{ color: COLOR_DESCRIPTION_DESTAQ }}>azul escuro</b> no board.
    </BaSeSmall1>
  );
  return (
    <>
      <BaSeGrid delimitedOnBreakpoint="mobile">
        <BaSeGridItem size={12}>
          {cache.getItem(cacheKeySebrae) !== 'NA' && listUfs.length > 0 ? (
            <UfFilterDisabled listUfs={listUfs} defaultUf={ufGestorDefault} />
          ) : (
            <BaSeOptionPicker
              label="UF do seminário:"
              values={listUfs}
              emptyValueLabel="Selecione"
              maxOptionsSelected={1}
              initialSelectedValuesId={selectedUF.map((val) => val.id)}
              onChange={(values) => {
                if (values.length === 0) return;
                getRegionalsbYuF(JSON.parse(values.map((val) => val.id)));

                getCitiesByUf({ id: JSON.parse(values.map((val) => val.id)) });

                setSelectedUF(values);
              }}
              extraActions={[
                {
                  action: () => {
                    setSelectedUF([]);
                    setSelectedCITY([]);
                  },
                  label: 'Limpar',
                },
              ]}
            />
          )}
        </BaSeGridItem>
        <BaSeGridItem size={12}>
          <BaSeOptionPicker
            label="Regional:"
            values={listRegionals || []}
            emptyValueLabel="Regional"
            maxOptionsSelected={1}
            initialSelectedValuesId={regionalSelected.map((val) => val.id)}
            onChange={(values) => {
              if (values.length === 0) return;
              setRegionalSelected(values);
              const valuesFormated = values[0].cities.map((item) => ({
                ...item,
                label: item.name,
              }));

              setListCityByRegional(valuesFormated);
            }}
          />
        </BaSeGridItem>
        <BaSeGridItem size={12}>
          <BaSeOptionPicker
            label="Cidade:"
            values={listCityByRegional || []}
            emptyValueLabel="Cidade"
            maxOptionsSelected={1}
            initialSelectedValuesId={selectedCITY.map((val) => val.id)}
            onChange={(values) => {
              if (values.length === 0) return;
              handleChange('moduleId', moduleSelected.id && moduleSelected.id);
              setSelectedCITY(values);
            }}
            extraActions={[
              {
                action: () => {
                  setSelectedCITY([]);
                },
                label: 'Limpar',
              },
            ]}
          />
        </BaSeGridItem>

        <BaSeGridItem size={6}>
          <BaSeDatePicker
            onStartDateChange={(date) => {
              setInitialDate(date)
              handleChange('beginDate', formatarData(date));
            }}
            startDate={initialDate}
            minDate={TODAY}
            maxDate={endDate ? new Date(endDate.getTime() - 86400000) : null}
            label="Data início"
            placeholder="00/00/0000"
          />
        </BaSeGridItem>
        <BaSeGridItem size={6}>
          <BaSeDatePicker
            onStartDateChange={(date) => {
              setEndDate(date)
              handleChange('endDate', formatarData(date));

            }}
            startDate={endDate}
            isDisabled={!initialDate}
            minDate={MORE_INITIAL_DATE}
            label="Data fim"
            placeholder="00/00/0000"
          />
        </BaSeGridItem>

        <BaSeGridItem size={12}>
          <BaSeInput
            color="default"
            currencyTyping="unlocked"
            inputMode="text"
            label="Valor do seminário:"
            mask="decimal"
            placeholder="R$"
            prefix="R$"
            size="medium"
            subLabel=""
            typeInput="text"
            width="100%"
            value={dtoCreateClass.seminarValue}
            onChange={(value) => {
              handleChange('seminarValue', value);
            }}
          />
        </BaSeGridItem>

        <BaSeGridItem size={12}>
          <AlignInformations>
            <BaSeCheckbox
              align="top-left"
              color="default"
              label="Ocultar turma no portal"
              value={acept}
              checked={acept}
              onChange={() => setAcept((prev) => !prev)}
              shape="square"
              size="medium"
            />
            <BaSePopupButton
              alertSize={270}
              iconProps={{
                color: undefined,
                name: 'exclamation-circle',
                size: 34,
              }}
              message={message}
              title="Title"
              type="tooltip"
            />
          </AlignInformations>
        </BaSeGridItem>
      </BaSeGrid>

      <AlignButtons>
        <BaSeButton
          onClick={() => {
            validate('close');
          }}
          type="primary"
          color={moduleSelected?.settingsMap?.primaryColor}
          loadingText="Carregando..."
          value="Salvar e criar"
        />
        <BaSeButton
          onClick={() => {
            validate('new');
          }}
          color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          type="secondary"
          loadingText="Carregando..."
          value="Salvar e criar nova"
        />
      </AlignButtons>
    </>
  );
}

export default FormCreateNewClassRoom;
